import { render, staticRenderFns } from "./BusinessListingTabs.vue?vue&type=template&id=2e141dbc&scoped=true&"
import script from "./BusinessListingTabs.vue?vue&type=script&lang=js&"
export * from "./BusinessListingTabs.vue?vue&type=script&lang=js&"
import style0 from "./BusinessListingTabs.vue?vue&type=style&index=0&id=2e141dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e141dbc",
  null
  
)

export default component.exports